import axios from 'axios'

const PrintingService = {
  async get (params = {}) {
    return axios.get('lo/withdrawal/printings', { params })
  },

  async histories (params = {}) {
    return axios.get('lo/reports/withdrawal/printing-histories', { params })
  },

  async show (id) {
    return axios.get(`lo/withdrawal/printings/${id}`)
  },

  async post (params = {}) {
    return axios.post('lo/withdrawal/printings', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`lo/withdrawal/printings/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`lo/withdrawal/printings/${data.id}`, { data })
  }
}

export default PrintingService
